export default __webpack_public_path__ + "fonts/iconfont.7e4c77ac0a90972b354a333fa5fc1be3.woff";